import angular from 'angular';
import uiRouter from 'angular-ui-router';
import managerAsEmployeeCalendarComponent from './managerAsEmployeeCalendar.component';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let managerAsEmployeeCalendarModule = angular.module('vacations-absences.managerAsEmployeeCalendar', [
  uiRouter
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR, {
        url: ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR,
        component: 'managerAsEmployeeCalendar'
      });
  })
  .component('managerAsEmployeeCalendar', managerAsEmployeeCalendarComponent)

  .name;

export default managerAsEmployeeCalendarModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendar/managerAsEmployeeCalendar.js